import { render, staticRenderFns } from "./DigiNavbar.vue?vue&type=template&id=63a09ee4&"
import script from "./DigiNavbar.vue?vue&type=script&lang=js&"
export * from "./DigiNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DigiNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports